/**
 * Author：brand
 * Creation Time：2019-06-04 10:45
 * Email：brandhuang@qq.com
 */

import {getToken, removeToken} from './auth'
import router from '@/router/router'

let flash_timer = null

let WSC_URL = process.env.VUE_APP_WSC_URL
export function initWebsocket(agentId) {
  //创建websocket连接
  const chatWS = new WebSocket(WSC_URL + '?from_uid=' + agentId)

  //当链接到服务器
  chatWS.onopen = () => {
    //发送握手数据
    const shake_hands_data = {
      type: "agentlogin",
      role: "agent",
      agent_uid: agentId,
      token: getToken()
    }
    //发送握手数据
    chatWS.send(JSON.stringify({
      agentlogin: {
        message: shake_hands_data
      }
    }))
  }
  //当从服务器接收消息后更新记录及UI
  chatWS.onmessage = (res) => {
    const resdata = JSON.parse(res.data)
    switch (resdata.type) {
    //心跳，服务端发送ping，客户端返回pong
      case "ping":
        chatWS.send(JSON.stringify({
          pong: {
            message: {
              type: "pong"
            }
          }
        }))
        break
    //来消息
      case "say":
        for (let uid in resdata.data) {
          //在浏览器标题上进行文字闪烁，提示用户
          let flash_text = resdata.data[uid].text,
          timing = 700,
          isFlash = true;
          chatWS.send(JSON.stringify({
            'sayback': {
              'message': {
                'from_uid': resdata.data[uid].from_uid,
                'role': 'client',
                'to_uid': resdata.data[uid].to_uid,
                'callingId': resdata.data[uid].callingId || ''
              }
            }
          }))
          if (flash_timer) clearInterval(flash_timer);

          flash_timer = setInterval(function () {
            if (isFlash) {
              document.title = "【您有新消息：" + flash_text + "】";
              isFlash = false;
            }
            else {
              document.title = "...";
              isFlash = true;
            }
          }, timing);
          eventBus.$emit('receivedMsg')
        }
        break
    // 账号异地登陆
      case "agentOffline":
        console.log('ws 踢下线')
        let msg = '你的账号于'+resdata.time+'在另一台'+resdata.msg+'登陆了，如非本人操作，则密码可能已泄露，建议修密码。'
        let tmp_data = {
          "type": 'agentlogout',
          "from_uid": agentId,
          "role": 'agent',
        }

        // window.vm.$store.state.user.ws.send(JSON.stringify({
        //   agentlogout: {
        //     message: tmp_data
        //   }
        // }))
        window.vm.$store.state.user.ws.close()
        eventBus.$emit('clearHistoryTimer')
        removeToken()
        window.vm.$confirm(msg, '下线通知', {
          closeOnClickModal:false,
          closeOnPressEscape:false,
          showCancelButton:false,
          showClose:false,
          confirmButtonText: '去登录',
          type: 'warning'
        }).then(() => {
          removeToken()
          window.location.reload()
          // window.vm.$store.dispatch('user/logout').then(res => {
          //   window.location.reload()
          // })
        }).catch(() => {
          removeToken()
          router.push({
            name: 'login'
          })
        });
        break
    }
  }

  //连接不上服务器，或者连接关闭后的提示
  chatWS.onclose = (e) => {
    chatWS.close()
    console.log('ws 关闭连接')
  }

  //连接发生错误
  chatWS.onerror = (e) => {
    console.log('ws 连接错误')
  }

  return chatWS
}
